import { CORE_RADIUS, THREAT_RADIUS } from './config.js';

/**
 * Sensors sense, never see: they report coarse distance bands only, never direction.
 * Bands are deliberately coarse so exact distances can't be used to work out an axis.
 */
export type CoreBand = 'none' | 'faint' | 'warm' | 'hot';
export type ThreatBand = 'none' | 'detected' | 'near' | 'danger';

/** Core sensor (4.0 rooms): FAINT 3.0–4.0, WARM 2.0–3.0, HOT under 2.0. */
export function coreBand(distance: number): CoreBand {
  if (distance > CORE_RADIUS) return 'none';
  if (distance < 2) return 'hot';
  if (distance < 3) return 'warm';
  return 'faint';
}

/** Threat sensor (2.5 rooms): DETECTED 2.0–2.5, NEAR 1.5–2.0, DANGER CLOSE under 1.5. */
export function threatBand(distance: number): ThreatBand {
  if (distance > THREAT_RADIUS) return 'none';
  if (distance < 1.5) return 'danger';
  if (distance < 2) return 'near';
  return 'detected';
}

export const CORE_BAND_LEVEL: Record<CoreBand, number> = { none: 0, faint: 1, warm: 2, hot: 3 };
export const THREAT_BAND_LEVEL: Record<ThreatBand, number> = { none: 0, detected: 1, near: 2, danger: 3 };
